

import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function BearishModel() {
    const apiModel = ChartstwitsRepository();

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('Down in 5 min');
    const [initialDisplayCount, setInitialDisplayCount] = useState(100);
    const [tickersearchdata, setsearchdata] = useState({
        search: ''
    });

    const [lstTopGainers, setTopGainers] = useState([{
        symbol: "",
        name: "",
        lastSale: "",
        netChange: "",
        pctChange: "",
        perChange: "",
        marketCap: "",
        url: ""
    }])

    const [lstFilterTopGainers, setFilterTopGainers] = useState([{
        symbol: "",
        name: "",
        lastSale: "",
        netChange: "",
        pctChange: "",
        perChange: "",
        marketCap: "",
        url: ""
    }])



    const selectTab = (e: any) => {
        debugger;
        setActiveTab(e);
        if (e == 'Down in 5 min') {
            getTopLosses();
        } else if (e == 'Gap Down') {
            getBearishGapdown();
        } else if (e == 'Low Volume') {
            getBearishLowVolumeDetails();
        } else if (e == 'Break Down') {
            getBearishBreakoutDetails();
        } else if (e == 'Down Trend') {
            getBearishDownTrendDetails();
        } else if (e == 'New Lows') {
            getBearishNewLowsDetails();
        }
    }

    const getTopLosses = async () => {
        debugger;
        // setTopGainers([]);
        const responseData: any = await apiModel.getTopLosses();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTopGainers(responseData);
        }
    }

    const getBearishGapdown = async () => {
        debugger;
        setTopGainers([]);
        const responseData: any = await apiModel.getBearishGapdown();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTopGainers(responseData);
        }
    }

    const getBearishLowVolumeDetails = async () => {
        debugger;
        setTopGainers([]);
        const responseData: any = await apiModel.getBearishLowVolumeDetails();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTopGainers(responseData);
        }
    }

    const getBearishBreakoutDetails = async () => {
        debugger;
        setTopGainers([]);
        const responseData: any = await apiModel.getBearishBreakoutDetails();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTopGainers(responseData);
        }
    }

    const getBearishDownTrendDetails = async () => {
        debugger;
        setTopGainers([]);
        const responseData: any = await apiModel.getBearishDownTrendDetails();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTopGainers(responseData);
        }
    }

    const getBearishNewLowsDetails = async () => {
        debugger;
        setTopGainers([]);
        const responseData: any = await apiModel.getBearishNewLowsDetails();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTopGainers(responseData);
        }
    }

    useEffect(() => {
        if (activeTab == 'Down in 5 min') {
            getTopLosses();
        }
    }, [activeTab])

    const back = () => {
        debugger;
        navigate(`/dashboard`);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        debugger;
        const searchdata = e.target.value;
        setsearchdata({ 'search': searchdata });
    }

    useEffect(() => {
        // debugger;
        if (tickersearchdata.search == '') {
            sliceMainDataArray();
        } else {
            let searchResults = lstTopGainers.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search)));
            setFilterTopGainers(searchResults)
        }
    }, [lstFilterTopGainers])


    useEffect(() => {
        if (tickersearchdata.search == '') {
            setInitialDisplayCount(100)
            sliceMainDataArray();
        } else {
            let searchResults = lstTopGainers.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search)));
            debugger;
            setFilterTopGainers(searchResults)
        }
    }, [tickersearchdata])

    const sliceMainDataArray = () => {
        const slicedData = lstTopGainers.slice(0, initialDisplayCount);
        setFilterTopGainers(slicedData);
    };

    const viewStockDetails = (d: any) => {
        // debugger;
        const queryParams = {
            ticker: d.symbol,
        };
        const queryString = new URLSearchParams(queryParams).toString();
        navigate(`/ticker-details?${queryString}`);
    }

    return { lstTopGainers, activeTab, selectTab, back, handleChange, lstFilterTopGainers, viewStockDetails }
}
